module.exports = __webpack_public_path__ + "static/media/banner-surga anjing liar-soon.8dad91a7.jpg";